import { Component, Input, OnInit, HostListener, ElementRef } from '@angular/core';
import { AlertController, ModalController, ToastController } from '@ionic/angular';
import { JavapiService } from '../../services/javapi.service';
import { MetodosgenService } from '../../services/metodosgen.service';
import { firstValueFrom } from 'rxjs';
import { Trabajo } from '../../models/trabajo';
import { Modelogeneraldatos } from 'src/app/models/modelogeneraldatos';
import { Metodosui } from 'src/app/services/metodosui';
import { SeleccionardatosComponent } from '../seleccionardatos/seleccionardatos.component';
import { InfomodalComponent, InfoSection, InfoItem } from '../infomodal/infomodal.component';
import { AdminCrudPage } from '../../pages/ajustes/admin-crud/admin-crud.page';
import { Modelogeneral } from '../../models/modelogeneral';

interface CotizacionItem {
  id: number;
  unidad: string;
  cantidad: number;
  descripcion: string;
  preUni: number;
  precio: number;
  areaId?: number;
  areaObj?: any;
}

@Component({
  selector: 'app-cotizacionesedit',
  templateUrl: './cotizacionesedit.component.html',
  styleUrls: ['./cotizacionesedit.component.scss'],
  standalone: false
})
export class CotizacioneseditComponent implements OnInit {

  @Input() trabajo: Trabajo | null = null;
  @Input() mode: 'add' | 'edit' = 'add';
  @Input() cotizacionId: number = 0;
  @Input() cotizacionData: any = null;
  @Input() parentType: 'solicitud' | 'trabajo' = 'trabajo';

  @Input() inspeccionId: number = 0;
  @Input() clientePre: any = null;
  @Input() direccionPre: any = null;
  @Input() solicitantePre: any = null;
  @Input() descripcionPre: string = '';
  @Input() itemsPre: any[] = [];
  @Input() inspeccionObj: any = null;
  @Input() isClone: boolean = false;
  @Input() basePrice: number = 0;

  currentStep: number = 1;

  // Form Data
  formData = {
    cliente: '',
    direccion: '',
    solicitante: '',
    fechaCot: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().split('T')[0],
    descripcion: '',
    materiales: false,
    ppc: false,
    observacion: '',
    estado: 'Borrador',
    applyItbms: true,
    // PPT Fields
    pptEnabled: false,
    pptSolicitanteId: 0,
    pptSolicitanteNombre: '',
    pptMonto: 0,
    pptFechaApply: null as any
  };

  // Items
  items: CotizacionItem[] = [];
  currentItem: CotizacionItem = {
    id: 0, unidad: 'glb', cantidad: 1, descripcion: '', preUni: 0, precio: 0
  };

  // Totals
  calcSubtotal: number = 0;
  calcItbms: number = 0;
  calcTotal: number = 0;

  // ── Autocomplete state (standalone mode only) ────────────────────────────
  clientesList: any[] = [];
  filteredClientes: any[] = [];
  showClienteDropdown = false;
  selectedClienteId: number = 0;

  direccionesList: any[] = [];
  filteredDirecciones: any[] = [];
  showDireccionDropdown = false;
  selectedDireccionId: number = 0;

  solicitantesList: any[] = [];
  filteredSolicitantes: any[] = [];
  filteredPptSolicitantes: any[] = [];
  showSolicitanteDropdown = false;
  selectedSolicitanteId: number = 0;

  isEditingItem: boolean = false;
  isSaving: boolean = false;

  observationTemplates: any[] = [];
  originalObservacion: string = '';

  tipoUnidadOptions: any[] = [];
  showUnidadDropdown: boolean = false;

  constructor(
    private modalCtrl: ModalController,
    private toastCtrl: ToastController,
    private alertCtrl: AlertController,
    private javapiService: JavapiService,
    private metodosGenService: MetodosgenService,
    private metodosUi: Metodosui,
    private el: ElementRef
  ) { }

  ngOnInit() {
    this.loadClientesList();
    this.loadSolicitantesList();
    this.loadUnidadesList();

    if (this.inspeccionId > 0) {
      if (this.clientePre) {
        this.formData.cliente = this.clientePre.nombre;
        this.selectedClienteId = this.clientePre.id;
      }
      if (this.direccionPre) {
        this.formData.direccion = this.direccionPre.nombre;
        this.selectedDireccionId = this.direccionPre.id;
      }
      if (this.solicitantePre) {
        this.formData.solicitante = this.solicitantePre.nombre;
        this.selectedSolicitanteId = this.solicitantePre.id;
      }
      if (this.descripcionPre) {
        this.formData.descripcion = this.descripcionPre;
      }
      if (this.itemsPre && this.itemsPre.length > 0) {
        this.items = this.itemsPre.map(ip => ({
          id: 0,
          unidad: 'glb',
          cantidad: 1,
          descripcion: ip.descripcion,
          preUni: 0,
          precio: 0,
          areaId: ip.areaId,
          areaObj: ip.areaObj
        }));
        setTimeout(() => this.calculateTotals(), 100);
      }
    }

    if (this.isClone && this.cotizacionData) {
      this.formData.cliente = this.cotizacionData.cliente || '';
      this.formData.direccion = this.cotizacionData.direccion || '';
      this.formData.solicitante = this.cotizacionData.solicitante || '';
      this.formData.fechaCot = new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().split('T')[0];
      this.formData.descripcion = this.cotizacionData.descripcion || '';
      this.formData.observacion = this.cotizacionData.observacion || '';
      this.formData.estado = 'Borrador';
      this.formData.applyItbms = Number(this.cotizacionData.itbms) > 0;
      this.formData.ppc = this.cotizacionData.ppc === 'Y';
      this.formData.materiales = this.cotizacionData.materiales === 'Y';

      this.selectedClienteId = Number(this.cotizacionData.clienteId) || 0;
      this.selectedDireccionId = Number(this.cotizacionData.direccionId) || 0;

      if (this.selectedClienteId) {
        this.loadDireccionesByCliente(this.selectedClienteId);
      }
    } else if (this.trabajo) {
      this.formData.materiales = this.trabajo.incluye_material === 'Y';

      if (this.mode === 'add') {
        this.formData.cliente = this.trabajo.cliente;
        this.formData.direccion = this.trabajo.lugar;
        this.formData.solicitante = this.trabajo.solicitante;
        this.formData.descripcion = this.trabajo.descripcion || '';
        if (this.parentType === 'trabajo') {
          this.formData.estado = 'Aprobada';
        }
        this.loadItemsFromTrabajo(); // Auto-load items from job
      } else if (this.mode === 'edit' && this.cotizacionData) {
        this.formData.cliente = this.cotizacionData.cliente;
        this.formData.direccion = this.cotizacionData.direccion;
        this.formData.solicitante = this.cotizacionData.solicitante || '';
        this.formData.fechaCot = this.cotizacionData.fecha;
        this.formData.descripcion = this.cotizacionData.descripcion;
        this.formData.materiales = this.trabajo.incluye_material === 'Y';
        this.formData.observacion = this.cotizacionData.observacion;
        this.formData.estado = this.cotizacionData.estado;
        this.formData.applyItbms = Number(this.cotizacionData.itbms) > 0;
        this.formData.ppc = this.cotizacionData.ppc === 'Y';
      }
    } else {
      if (this.mode === 'edit' && this.cotizacionData) {
        this.formData.cliente = this.cotizacionData.cliente || '';
        this.formData.direccion = this.cotizacionData.direccion || '';
        this.formData.solicitante = this.cotizacionData.solicitante || '';
        this.formData.fechaCot = this.cotizacionData.fecha;
        this.formData.descripcion = this.cotizacionData.descripcion;
        this.formData.observacion = this.cotizacionData.observacion;
        this.formData.estado = this.cotizacionData.estado;
        this.formData.applyItbms = Number(this.cotizacionData.itbms) > 0;
        this.formData.ppc = this.cotizacionData.ppc === 'Y';
        this.formData.materiales = this.cotizacionData.materiales === 'Y';

        // Pre-set selected IDs so saving works and direcciones filter correctly
        this.selectedClienteId = Number(this.cotizacionData.clienteId) || 0;
        this.selectedDireccionId = Number(this.cotizacionData.direccionId) || 0;

        // Load direcciones for the existing client so the dropdown is populated
        if (this.selectedClienteId) {
          this.loadDireccionesByCliente(this.selectedClienteId);
        }
      }
    }
    this.originalObservacion = this.formData.observacion || '';

    if (this.cotizacionId) {
      this.loadCotizacionData();
    }
    this.calculateTotals();
    this.loadObservationTemplates();
    if (this.cotizacionId) {
      this.loadPptData();
    }
    
  }

  async loadPptData() {
    if (!this.cotizacionId) return;
    const json: Modelogeneral = {
      empresa: "pgarcia2",
      rutina: "cotizaciones",
      subrutina: "cotizacionGetPpt",
      usuario: "system",
      datos: { dt1: String(this.cotizacionId), dt2: "", dt3: "", dt4: "", dt5: "", dt6: "", dt7: "", dt8: "", dt9: "", dt10: "", dt11: "", dt12: "", dt13: "", dt14: "", dt15: "" }
    };
    try {
      const res = await firstValueFrom(this.javapiService.getCommonModel(json));
      if (res && res.length > 0) {
        const ppt = res[0];
        // En MySQL genModel, las columnas se mapean en orden:
        // dt1: c_id, dt2: solicitante_id, dt3: monto, dt4: fecha_apply, dt5: solicitante_nombre
        this.formData.pptSolicitanteId = Number(ppt.dt2);
        this.formData.pptMonto = Number(ppt.dt3);
        this.formData.pptFechaApply = ppt.dt4;
        this.formData.pptSolicitanteNombre = ppt.dt5;
        
        // No activamos el toggle automáticamente por solicitud del usuario
        // this.formData.pptEnabled = true;
        
        // Re-calcular totales por si acaso el monto PPT debe mostrarse (aunque no se sume al total final según el último cambio)
        this.calculateTotals();
      }
    } catch (e) {
      console.error('Error loading PPT data', e);
    }
  }

  async loadObservationTemplates() {
    try {
      const res: any = await firstValueFrom(this.javapiService.getJsonParam('CT_OBS_COTIZACIONES'));
      if (res && res.pa_json) {
        this.observationTemplates = JSON.parse(res.pa_json);
      }
    } catch (e) {
      console.error('Error loading observation templates', e);
    }
  }

  applyTemplate(template: any) {
    if (template === 'restore') {
      this.formData.observacion = this.originalObservacion;
      return;
    } 
    if (template === 'clear') {
      this.formData.observacion = '';
      return;
    }
    
    if (template && template.texto) {
      const cleanText = template.texto.replace(/\r\n/g, '\n').trim();
      let currentObs = (this.formData.observacion || '').replace(/\r\n/g, '\n').trim();
      
      // Escapamos el texto para usarlo en una expresión regular
      const escaped = cleanText.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      // Buscamos el bloque exacto (rodeado por inicio, fin o saltos de línea)
      const blockRegex = new RegExp(`(^|\\n)${escaped}(\\n|$)`);

      if (blockRegex.test(currentObs)) {
        // SI EXISTE: Lo quitamos.
        let newObs = currentObs.replace(blockRegex, '$1').trim();
        this.formData.observacion = newObs.replace(/\n+/g, '\n');
      } else {
        // NO EXISTE: Lo agregamos al final con un solo salto de línea
        this.formData.observacion = currentObs ? `${currentObs}\n${cleanText}` : cleanText;
      }
    }
  }

  isTemplateActive(text: string): boolean {
    if (!this.formData.observacion || !text) return false;
    const cleanObs = this.formData.observacion.replace(/\r\n/g, '\n').trim();
    const cleanText = text.replace(/\r\n/g, '\n').trim();
    
    const escaped = cleanText.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const blockRegex = new RegExp(`(^|\\n)${escaped}(\\n|$)`);
    
    return blockRegex.test(cleanObs);
  }

  async loadItemsFromTrabajo() {
    if (!this.trabajo) return;
    try {
      const data: any = await firstValueFrom(
        this.javapiService.getCommonModel(
          this.metodosGenService.setModeloGeneral('selDtsList', 'trabajosItems', String(this.trabajo.id), '', '', '', '', '', '', '', '', '', '', '', '', '', '')
        )
      );
      if (Array.isArray(data) && data.length > 0) {
        this.items = data.map(item => {
          const desc = String(item.dt2 || item.descripcion || '').trim();
          const unit = String(item.dt3 || item.medida || 'glb').toLowerCase();
          const qty = Number(item.dt4 || item.cantidad) || 1;
          
          return {
            id: 0,
            unidad: this.getAbbreviationFromAny(unit),
            cantidad: qty,
            descripcion: desc,
            preUni: 0,
            precio: 0
          };
        }).filter(item => item.descripcion !== '');
      } else {
        // Si el trabajo no tiene ítems detallados, pero tiene una descripción general,
        // creamos un ítem global por defecto
        if (this.trabajo.descripcion) {
          this.items = [{
            id: 0,
            unidad: 'glb',
            cantidad: 1,
            descripcion: this.trabajo.descripcion.trim(),
            preUni: 0,
            precio: 0
          }];
        }
      }
      // Si viene basePrice desde trabajosmenu, aplicarlo al primer item cargado
      if (this.basePrice > 0 && this.items.length > 0) {
        this.items[0].preUni = this.basePrice;
        this.items[0].precio = this.items[0].cantidad * this.basePrice;
      }
      this.updateDescription();
      this.calculateTotals();
    } catch (e) {
      console.error('Error auto-loading items from job:', e);
    }
  }

  // ── Lists Loading ────────────────────────────────────────────────────────
  async loadClientesList() {
    try {
      const data: any = await firstValueFrom(
        this.javapiService.getCommonModel(
          this.metodosGenService.setModeloGeneral('selDtsList', 'listClientes', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '')
        )
      );
      if (Array.isArray(data)) {
        this.clientesList = data.map(c => ({ id: Number(c.dt1), nombre: c.dt2 }));

        // Sort alphabetically first
        this.clientesList.sort((a, b) => a.nombre.localeCompare(b.nombre));

        // Prioritize "Inmobiliaria Don Antonio"
        const index = this.clientesList.findIndex(c => c.nombre.trim().toLowerCase() === 'inmobiliaria don antonio');
        if (index > -1) {
          const prioritized = this.clientesList.splice(index, 1)[0];
          this.clientesList.unshift(prioritized);
        }

        // Map ID back from name if in edit mode, clone mode or when loading from a trabajo
        if ((this.mode === 'edit' || this.isClone || this.trabajo) && !this.selectedClienteId && this.formData.cliente) {
          const match = this.clientesList.find(c => c.nombre === this.formData.cliente);
          if (match) {
            this.selectedClienteId = match.id;
            this.loadDireccionesByCliente(match.id);
          }
        }
        
        // Sync filtered list to ensure immediately updated autocomplete options
        this.filteredClientes = [...this.clientesList];
      }
    } catch (e) { console.error('Error loading clientes', e); }
  }

  async loadDireccionesByCliente(clienteId: number) {
    try {
      const data: any = await firstValueFrom(
        this.javapiService.getCommonModel(
          this.metodosGenService.setModeloGeneral('selDtsList', 'listLugaresAll', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '')
        )
      );
      if (Array.isArray(data)) {
        const all = data.map(c => ({ id: Number(c.dt1), nombre: c.dt2, id_cliente: Number(c.dt3) }));
        this.direccionesList = all.filter(d => d.id_cliente === clienteId);
        this.filteredDirecciones = [...this.direccionesList];

        // Map ID back from name if in edit mode, clone mode or when loading from a trabajo
        if ((this.mode === 'edit' || this.isClone || this.trabajo) && !this.selectedDireccionId && this.formData.direccion) {
          const match = this.direccionesList.find(d => d.nombre === this.formData.direccion);
          if (match) {
            this.selectedDireccionId = match.id;
          }
        }
      }
    } catch (e) { console.error('Error loading direcciones', e); }
  }

  async loadSolicitantesList() {
    try {
      const data: any = await firstValueFrom(
        this.javapiService.executeAdminCrud('SOLICITANTE', 'SELECT_ALL', { dt1: '' })
      );
      if (Array.isArray(data)) {
        this.solicitantesList = data.map(c => ({ 
          id: Number(c.dt1), 
          nombre: c.dt2,
          clienteId: Number(c.dt6) // Corrected from dt3 to dt6 using full Admin CRUD data
        }));

        // Map ID back from name if in edit mode, clone mode or when loading from a trabajo
        if ((this.mode === 'edit' || this.isClone || this.trabajo) && !this.selectedSolicitanteId && this.formData.solicitante) {
          const match = this.solicitantesList.find(s => s.nombre === this.formData.solicitante);
          if (match) {
            this.selectedSolicitanteId = match.id;
          }
        }
        
        // Sync filtered list to ensure immediately updated autocomplete options
        this.filteredSolicitantes = [...this.solicitantesList];
      }
    } catch (e) { console.error('Error loading solicitantes', e); }
  }

  async loadUnidadesList() {
    try {
      this.javapiService.getJsonParam('fe_lista_uni_cant').subscribe(res => {
        const jsonContent = res.pa_json || res.dt3;
        if (jsonContent) {
          const list = typeof jsonContent === 'string' ? JSON.parse(jsonContent) : jsonContent;
          if (Array.isArray(list)) {
            this.tipoUnidadOptions = list.map(u => ({
              label: `${u.nombre} (${u.abreviatura})`,
              value: u.abreviatura
            }));
            
            // Normalize all loaded items to use abbreviations if they have full names
            this.items.forEach(item => {
              item.unidad = this.getAbbreviationFromAny(item.unidad);
            });
            
            // Normalize current item default
            this.currentItem.unidad = this.getAbbreviationFromAny(this.currentItem.unidad);
          }
        }
      });
    } catch (e) { console.error('Error loading unidades', e); }
  }

  getAbbreviationFromAny(val: string): string {
    if (!val) return 'glb';
    const lower = val.toLowerCase().trim();
    
    // 1. Try to find if it's already a value (abbreviation)
    const optByValue = this.tipoUnidadOptions.find(o => o.value.toLowerCase() === lower);
    if (optByValue) return optByValue.value;
    
    // 2. Try to find if it matches part of a label (full name)
    const optByLabel = this.tipoUnidadOptions.find(o => o.label.toLowerCase().includes(lower));
    if (optByLabel) return optByLabel.value;
    
    return lower;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    if (!this.el.nativeElement.contains(event.target)) {
      this.closeAllDropdowns();
    } else {
      const target = event.target as HTMLElement;
      if (!target.closest('.autocomplete-wrapper')) {
        this.closeAllDropdowns();
      }
    }
  }

  closeAllDropdowns() {
    this.showClienteDropdown = false;
    this.showDireccionDropdown = false;
    this.showSolicitanteDropdown = false;
    this.showUnidadDropdown = false;
  }

  // ── Autocomplete: Cliente ────────────────────────────────────────────────
  filterClientes(event: any) {
    const q = (event.target?.value || '').toLowerCase();
    this.formData.cliente = event.target?.value || '';
    
    // Show list filtered by query, or all if empty
    this.filteredClientes = this.clientesList.filter(c => c.nombre.toLowerCase().includes(q));
    this.showClienteDropdown = true;
    
    // Close others
    this.showDireccionDropdown = false;
    this.showSolicitanteDropdown = false;

    // Clear related if text changed and was previously selected
    if (this.selectedClienteId && !this.filteredClientes.some(c => c.nombre.toLowerCase() === q)) {
      this.selectedClienteId = 0;
      this.selectedDireccionId = 0;
      this.direccionesList = [];
      this.filteredDirecciones = [];
      this.formData.direccion = '';
    }
  }

  selectCliente(c: any) {
    this.formData.cliente = c.nombre;
    this.selectedClienteId = c.id;
    this.showClienteDropdown = false;
    this.filteredClientes = [];
    this.formData.direccion = '';
    this.selectedDireccionId = 0;
    this.loadDireccionesByCliente(c.id);
  }

  clearCliente() {
    this.formData.cliente = '';
    this.selectedClienteId = 0;
    this.selectedDireccionId = 0;
    this.showClienteDropdown = false;
    this.filteredClientes = [];
    this.formData.direccion = '';
    this.direccionesList = [];
    this.filteredDirecciones = [];
    this.showDireccionDropdown = false;
  }

  clearDireccion() {
    this.formData.direccion = '';
    this.selectedDireccionId = 0;
    this.showDireccionDropdown = false;
    this.filteredDirecciones = [];
  }

  clearSolicitante() {
    this.formData.solicitante = '';
    this.selectedSolicitanteId = 0;
    this.showSolicitanteDropdown = false;
    this.filteredSolicitantes = [];
  }

  hideDropdown(type: string) {
    setTimeout(() => {
      if (type === 'cliente') this.showClienteDropdown = false;
      if (type === 'direccion') this.showDireccionDropdown = false;
      if (type === 'solicitante') this.showSolicitanteDropdown = false;
    }, 200);
  }

  async createCliente() {
    this.showClienteDropdown = false;
    const modal = await this.modalCtrl.create({
      component: AdminCrudPage,
      componentProps: {
        entity: 'CLIENTE',
        autoOpenAdd: true,
        initialData: {
          dt2: this.formData.cliente
        }
      },
      cssClass: 'custom-modal'
    });
    await modal.present();
    const { data } = await modal.onWillDismiss();
    
    if (data) {
      await this.loadClientesList();
      const newName = data.nombre || data.dt2 || this.formData.cliente;
      
      const match = this.clientesList.find(c => c.nombre.toLowerCase().trim() === newName.toLowerCase().trim());
      if (match) {
        this.selectCliente(match);
      } else {
        const newId = Number(data.id) || 0;
        this.selectCliente({ id: newId, nombre: newName });
      }
    }
  }

  async offerCreateDireccion(cliente: any) {
    const alert = await this.alertCtrl.create({
      header: `¿Agregar dirección para "${cliente.nombre}"?`,
      cssClass: 'custom-alert',
      buttons: [
        { text: 'Ahora no', role: 'cancel', cssClass: 'alert-button' },
        {
          text: 'Sí, agregar',
          cssClass: 'alert-button',
          handler: async () => {
            await this.createDireccionForCliente(cliente.id);
          }
        }
      ]
    });
    await alert.present();
  }

  // ── Autocomplete: Dirección ──────────────────────────────────────────────
  filterDirecciones(event: any) {
    if (!this.selectedClienteId) return;
    const q = (event.target?.value || '').toLowerCase();
    this.formData.direccion = event.target?.value || '';
    
    this.filteredDirecciones = this.direccionesList.filter(d => d.nombre.toLowerCase().includes(q));
    this.showDireccionDropdown = true;
    
    // Close others
    this.showClienteDropdown = false;
    this.showSolicitanteDropdown = false;
  }

  selectDireccion(d: any) {
    this.formData.direccion = d.nombre;
    this.selectedDireccionId = d.id;
    this.showDireccionDropdown = false;
    this.filteredDirecciones = [];
  }

  focusDireccionInput() {
    if (this.selectedClienteId && this.direccionesList.length >= 0) {
      this.filteredDirecciones = [...this.direccionesList];
      this.showDireccionDropdown = true;
    }
  }

  async createDireccionForCliente(clienteId: number) {
    const cliente = this.clientesList.find(c => c.id === clienteId);
    const alert = await this.alertCtrl.create({
      header: 'Nueva Dirección',
      subHeader: cliente ? `Para cliente: ${cliente.nombre}` : '',
      cssClass: 'custom-alert',
      inputs: [
        { name: 'nombre', type: 'text', placeholder: 'Nombre del lugar / dirección *', value: this.formData.direccion }
      ],
      buttons: [
        { text: 'Cancelar', role: 'cancel', cssClass: 'alert-button' },
        {
          text: 'Crear',
          cssClass: 'alert-button',
          handler: async (data) => {
            if (!data.nombre?.trim()) return false;
            try {
              const res: any = await firstValueFrom(
                this.javapiService.getCommonModel(
                  this.metodosGenService.setModeloGeneral('genInsert', 'insertDireccion', data.nombre.trim(), String(clienteId), '', '', '', '', '', '', '', '', '', '', '', '', '')
                )
              );
              const newId = Array.isArray(res) ? Number(res[0].dt1) : 0;
              const newDir = { id: newId, nombre: data.nombre.trim(), id_cliente: clienteId };
              this.direccionesList.push(newDir);
              this.selectDireccion(newDir);
              this.selectedDireccionId = newId;
            } catch (e) { console.error('Error creating direccion', e); }
            return true;
          }
        }
      ]
    });
    await alert.present();
  }

  async createDireccion() {
    this.showDireccionDropdown = false;
    if (!this.selectedClienteId) {
      await this.metodosUi.showToast('Selecciona primero un cliente para agregar una dirección', 'warning');
      return;
    }
    
    const modal = await this.modalCtrl.create({
      component: AdminCrudPage,
      componentProps: {
        entity: 'DIRECCION',
        autoOpenAdd: true,
        initialData: {
          dt2: String(this.selectedClienteId),
          dt5: this.formData.direccion
        }
      },
      cssClass: 'custom-modal'
    });
    await modal.present();
    const { data } = await modal.onWillDismiss();

    if (data) {
      await this.loadDireccionesByCliente(this.selectedClienteId);
      const newName = data.nombre || data.dt2 || this.formData.direccion;
      
      const match = this.direccionesList.find(d => d.nombre.toLowerCase().trim() === newName.toLowerCase().trim());
      if (match) {
        this.selectDireccion(match);
      } else {
        const newId = Number(data.id) || 0;
        this.selectDireccion({ id: newId, nombre: newName, id_cliente: this.selectedClienteId });
      }
    }
  }

  // ── Autocomplete: Solicitante ────────────────────────────────────────────
  filterSolicitantes(event: any) {
    const q = (event.target?.value || '').toLowerCase();
    this.formData.solicitante = event.target?.value || '';
    
    this.filteredSolicitantes = this.solicitantesList.filter(s => s.nombre.toLowerCase().includes(q));
    this.showSolicitanteDropdown = true;
    
    // Close others
    this.showClienteDropdown = false;
    this.showDireccionDropdown = false;
  }

  selectSolicitante(s: any) {
    this.formData.solicitante = s.nombre;
    this.selectedSolicitanteId = s.id;
    this.showSolicitanteDropdown = false;
    this.filteredSolicitantes = [];

    // Auto-select client if linked
    if (s.clienteId) {
      const client = this.clientesList.find(c => c.id === s.clienteId);
      if (client) {
        this.selectCliente(client);
      }
    }
  }

  async createSolicitante() {
    this.showSolicitanteDropdown = false;
    const modal = await this.modalCtrl.create({
      component: AdminCrudPage,
      componentProps: {
        entity: 'SOLICITANTE',
        autoOpenAdd: true,
        initialData: {
          dt6: String(this.selectedClienteId || ''),
          dt2: this.formData.solicitante
        }
      },
      cssClass: 'custom-modal'
    });
    await modal.present();
    const { data } = await modal.onWillDismiss();

    if (data) {
      await this.loadSolicitantesList();
      const newName = data.nombre || data.dt2 || this.formData.solicitante;
      
      const match = this.solicitantesList.find(s => s.nombre.toLowerCase().trim() === newName.toLowerCase().trim());
      if (match) {
        this.selectSolicitante(match);
      } else {
        const newId = Number(data.id) || 0;
        this.selectSolicitante({ id: newId, nombre: newName });
      }
    }
  }

  doesSolicitanteExist(name: string): boolean {
    if (!name) return false;
    const clean = name.trim().toLowerCase();
    return this.solicitantesList.some(s => s.nombre?.trim().toLowerCase() === clean);
  }

  doesClienteExist(name: string): boolean {
    if (!name) return false;
    const clean = name.trim().toLowerCase();
    return this.clientesList.some(c => c.nombre?.trim().toLowerCase() === clean);
  }

  doesDireccionExist(name: string): boolean {
    if (!name) return false;
    const clean = name.trim().toLowerCase();
    return this.direccionesList.some(d => d.nombre?.trim().toLowerCase() === clean);
  }

  // ── Existing methods ─────────────────────────────────────────────────────
  async loadCotizacionData() {
    try {
      const data: any = await firstValueFrom(
        this.javapiService.getCommonModel(
          this.metodosGenService.setModeloGeneral(
            "cotizaciones", "cotizacionGet", String(this.cotizacionId), '', '', '', '', '', '', '', '', '', '', '', '', '', ''
          )
        )
      );
      if (Array.isArray(data) && data.length > 0) {
        this.items = data.filter(d => d.dt1 !== 'HEADER').map(c => ({
          id: Number(c.dt1) || 0,
          descripcion: c.dt2,
          cantidad: Number(c.dt3) || 0,
          unidad: this.getAbbreviationFromAny(c.dt4 || 'glb'),
          preUni: Number(c.dt5) || 0,
          precio: (Number(c.dt3) || 0) * (Number(c.dt5) || 0)
        }));
        this.updateDescription();
        this.calculateTotals();
      }
    } catch (e) { console.error('Error loading cotizacion details:', e); }
  }

  async nextStep() {
    if (this.currentStep === 1) {
      if (!this.formData.cliente || !this.selectedClienteId) {
        await this.metodosUi.showToast('Debes seleccionar un cliente válido de la lista', 'warning');
        return;
      }
      if (!this.formData.direccion || !this.selectedDireccionId) {
        await this.metodosUi.showToast('Debes seleccionar una dirección válida de la lista', 'warning');
        return;
      }
      if (!this.formData.solicitante || !this.selectedSolicitanteId) {
        await this.metodosUi.showToast('Debes seleccionar un solicitante válido de la lista', 'warning');
        return;
      }
      if (!this.formData.fechaCot) {
        await this.metodosUi.showToast('La fecha de cotización es obligatoria', 'warning');
        return;
      }
    }
    if (this.currentStep === 2) {
      if (this.items.length === 0) {
        await this.metodosUi.showToast('Agrega al menos un item antes de continuar', 'warning');
        return;
      }

      if (this.calcTotal <= 1) {
        await this.metodosUi.showToast('El monto total de la cotización debe ser mayor a $1.00', 'warning');
        return;
      }
    }
    this.currentStep++;
  }
  prevStep() { this.currentStep--; }
  close() { this.modalCtrl.dismiss(); }

  calculateItemTotal() {
    this.currentItem.precio = this.currentItem.cantidad * this.currentItem.preUni;
  }

  addItem() {
    if (!this.currentItem.descripcion || this.currentItem.descripcion.trim() === '') {
      this.presentToast('La descripción del item es obligatoria');
      return;
    }
    if (!this.currentItem.preUni || this.currentItem.preUni <= 0) {
      this.presentToast('El precio debe ser mayor a 0');
      return;
    }
    if (this.currentItem.cantidad > 0) {
      this.calculateItemTotal();
      this.currentItem.descripcion = this.sanitizeText(this.currentItem.descripcion);
      this.items.push({ ...this.currentItem });
      this.currentItem = { id: 0, unidad: 'glb', cantidad: 1, descripcion: '', preUni: 0, precio: 0 };
      this.isEditingItem = false;
      this.selectedDescMode = null;
      this.originalDescText = '';
      this.improvedDescText = '';
      this.ajustePrecio = null;
      this.updateDescription();
      this.calculateTotals();
    }
  }

  editItem(index: number) {
    if (this.currentItem.descripcion || this.currentItem.cantidad > 1 || this.currentItem.preUni > 0) {
      this.calculateItemTotal();
      this.currentItem.descripcion = this.sanitizeText(this.currentItem.descripcion);
      this.items.push({ ...this.currentItem });
    }
    const item = this.items[index];
    this.currentItem = { ...item };
    this.isEditingItem = true;
    this.selectedDescMode = null;
    this.originalDescText = '';
    this.improvedDescText = '';
    this.ajustePrecio = null;
    this.items.splice(index, 1);
    this.updateDescription();
    this.calculateTotals();
  }

  removeItem(index: number) {
    this.items.splice(index, 1);
    this.isEditingItem = false;
    this.selectedDescMode = null;
    this.originalDescText = '';
    this.improvedDescText = '';
    this.ajustePrecio = null;
    this.updateDescription();
    this.calculateTotals();
  }

  // ── Custom Dropdown: Unidad ──────────────────────────────────────────────
  toggleUnidadDropdown() {
    this.showUnidadDropdown = !this.showUnidadDropdown;
  }

  selectUnidad(value: string) {
    this.currentItem.unidad = value;
    this.showUnidadDropdown = false;
    this.calculateItemTotal();
  }

  getUnidadLabel(value: string): string {
    const opt = this.tipoUnidadOptions.find(o => o.value === value);
    return opt ? opt.label : 'Seleccionar';
  }

  updateDescription() {
    const sortedItems = [...this.items].sort((a, b) => a.id - b.id);
    this.formData.descripcion = sortedItems.map(i => i.descripcion).join('; ');
  }

  calculateTotals() {
    this.calcSubtotal = this.items.reduce((acc, item) => acc + (Number(item.precio) || 0), 0);
    this.calcItbms = this.formData.applyItbms ? this.calcSubtotal * 0.07 : 0;
    this.calcTotal = this.calcSubtotal + this.calcItbms;
  }

  sanitizeText(text: string): string {
    if (!text) return '';
    return text
      .replace(/\u00A0/g, ' ')  // Replace non-breaking spaces with standard space
      .replace(/[\u200B-\u200D\uFEFF]/g, '') // Remove zero-width spaces/joiners and BOM
      .replace(/\u200E/g, '')   // Remove LTR mark
      .replace(/\u200F/g, '');  // Remove RTL mark
  }

  async openImportModal() {
    if (!this.trabajo) return;
    const modal = await this.modalCtrl.create({
      component: SeleccionardatosComponent,
      componentProps: {
        titulo: 'Importar Items del Trabajo',
        subrutina: 'trabajosItems',
        spr1: String(this.trabajo.id),
        tipo: 'multiple',
        hiddenCols: ['dt1']
      }
    });
    await modal.present();
    const { data } = await modal.onDidDismiss();
    if (data && data.action === 'selected' && data.data) {
      const selectedItems = Array.isArray(data.data) ? data.data : [data.data];
      selectedItems.forEach((item: any) => {
        this.items.push({
          id: 0, unidad: 'glb', cantidad: 1,
          descripcion: item.dt2 || item.descripcion || '',
          preUni: 0, precio: 0
        });
      });
      this.updateDescription();
      this.calculateTotals();
      this.metodosUi.showToast(`Se importaron ${selectedItems.length} items`, 'success');
    }
  }

  async viewItemDetail(item: CotizacionItem) {
    if (!item.areaId) return;

    try {
      this.metodosUi.showLoading('Cargando resumen...', 'blue');
      
      const [medidasRes, estimadosRes]: [Modelogeneraldatos[], any[]] = await Promise.all([
        firstValueFrom(
          this.javapiService.getCommonModel(
            this.metodosGenService.setModeloGeneral(
              "genModel", "inspeccionMedidas", String(item.areaId), "", "", "", "", "", "", "", "", "", "", "", "", "", ""
            )
          )
        ).catch(() => []),
        firstValueFrom(this.javapiService.getInspeccionEstimadosList(String(item.areaId))).catch(() => [])
      ]);

      this.metodosUi.hideLoading();

      const sections: InfoSection[] = [];

      // 1. Measures Summary (Separating M2 and ML)
      if (medidasRes && medidasRes.length > 0) {
        let totalM2 = 0;
        let totalML = 0;
        let totalUnid = 0;
        let unitM2 = '';
        let unitML = '';
        let unitUnid = '';

        const mappedItems = medidasRes.map(m => {
          const val = Number(m.dt6) || 0;
          const type = m.dt9; // lineal, cuadrada, unidad
          const unit = m.dt5 || '';

          if (type === 'cuadrada') { totalM2 += val; unitM2 = unit; }
          else if (type === 'lineal') { totalML += val; unitML = unit; }
          else { totalUnid += val; unitUnid = unit; }

          let detail = '';
          if (type === 'lineal') detail = `${m.dt8} x ${m.dt3}${unit}`;
          else if (type === 'unidad') detail = `${m.dt8} ${unit}`;
          else detail = `${m.dt8} x ${m.dt3}x${m.dt4}${unit}`;

          return {
            type: type,
            label: `${m.dt2} (${detail})`,
            value: `${val.toFixed(2)} ${unit}${type === 'cuadrada' ? '²' : ''}`,
            icon: type === 'lineal' ? 'trending-up-outline' : type === 'unidad' ? 'list-outline' : 'resize-outline'
          };
        });

        const m2Items: InfoItem[] = mappedItems.filter(m => m.type === 'cuadrada').map(({type, ...item}) => item);
        const mlItems: InfoItem[] = mappedItems.filter(m => m.type === 'lineal').map(({type, ...item}) => item);
        const unitItems: InfoItem[] = mappedItems.filter(m => m.type === 'unidad').map(({type, ...item}) => item);

        if (m2Items.length > 0) {
          sections.push({
            title: 'Medidas de Área (M²)',
            items: [
              ...m2Items,
              { label: 'TOTAL ÁREA (M²)', value: `${totalM2.toFixed(2)} ${unitM2}²`, valueClass: 'bold-value', icon: 'calculator-outline' }
            ]
          });
        }

        if (mlItems.length > 0) {
          sections.push({
            title: 'Medidas Lineales (ML)',
            items: [
              ...mlItems,
              { label: 'TOTAL LINEAL (ML)', value: `${totalML.toFixed(2)} ${unitML}`, valueClass: 'bold-value', icon: 'trending-up-outline' }
            ]
          });
        }

        if (unitItems.length > 0) {
          sections.push({
            title: 'Unidades y Otros',
            items: [
              ...unitItems,
              { label: 'TOTAL UNIDADES', value: `${totalUnid.toFixed(2)} ${unitUnid}`, valueClass: 'bold-value', icon: 'list-outline' }
            ]
          });
        }
      }

      // 2. Estimates Summary
      if (estimadosRes && estimadosRes.length > 0) {
        let totalEstimados = 0;
        const estimateItems = estimadosRes
          .filter(e => e.dt2 !== 'GENERAL') // Skip 'General' type as requested
          .map(e => {
            let cost = Number(e.dt8) || 0; // Use dt8 for cost (total calculated in DB or fix)
            
            // Fallback for old records where cost might be 0
            if (cost === 0 && e.dt2 === 'PLANILLA') {
              cost = (Number(e.dt6) || 0) * (Number(e.dt3) || 0) * (Number(e.dt4) || 0);
            } else if (cost === 0 && e.dt2 === 'MATERIAL') {
              cost = (Number(e.dt6) || 0) * (Number(e.dt7) || 0);
            }

            totalEstimados += cost;
            const label = e.dt2 === 'PLANILLA' 
              ? `Planilla: ${e.dt4} pers. x ${e.dt3} días` 
              : e.dt2 === 'MATERIAL' 
                ? `Material: ${e.dt7} unid. (${e.dt10 || ''})`
                : e.dt2 === 'MOVILIDAD'
                  ? `Movilidad: ${e.dt3} días x $${e.dt6}`
                  : e.dt2 === 'SUBCONTRATO'
                    ? `Subcontrato: ${e.dt9} (${e.dt10 || ''})`
                    : `${e.dt2}: ${e.dt10 || ''}`;
            
            return {
              label: label,
              value: `$${cost.toLocaleString('en-US', { minimumFractionDigits: 2 })}`,
              icon: 'cash-outline'
            };
          });

        if (estimateItems.length > 0) {
          sections.push({
            title: 'Costos estimados',
            items: [
              ...estimateItems,
              { label: 'TOTAL ESTIMADO', value: `$${totalEstimados.toLocaleString('en-US', { minimumFractionDigits: 2 })}`, valueClass: 'bold-value', icon: 'wallet-outline' }
            ]
          });
        }
      }

      if (sections.length === 0) {
        this.metodosUi.showToast('No hay medidas ni estimados registrados para esta área', 'warning');
        return;
      }

      await this.metodosUi.openModal(InfomodalComponent, {
        title: `Detalle: ${item.areaObj?.area || 'Item'}`,
        sections: sections
      });

    } catch (e) {
      this.metodosUi.hideLoading();
      console.error('Error loading detail summary:', e);
      this.metodosUi.showToast('Error al cargar la información', 'danger');
    }
  }

  async presentToast(message: string, color: string = 'warning') {
    await this.metodosUi.showToast(message, color);
  }

  onPptEnabledChange() {
    if (this.formData.pptEnabled && (!this.formData.pptSolicitanteId || this.formData.pptSolicitanteId === 0)) {
      // Default to the quotation's solicitante as requested
      this.formData.pptSolicitanteId = this.selectedSolicitanteId;
      this.formData.pptSolicitanteNombre = this.formData.solicitante;
    }
    this.calculateTotals();
  }

  filterPptSolicitantes(event: any) {
    const val = event.target.value.toLowerCase();
    this.formData.pptSolicitanteNombre = event.target.value;
    if (!val) {
      this.filteredPptSolicitantes = [];
      this.formData.pptSolicitanteId = 0;
      return;
    }
    this.filteredPptSolicitantes = this.solicitantesList.filter(s => s.nombre.toLowerCase().includes(val));
    
    const exact = this.solicitantesList.find(s => s.nombre.toLowerCase() === val);
    if (exact) {
      this.formData.pptSolicitanteId = exact.id;
    } else {
      this.formData.pptSolicitanteId = 0;
    }
  }

  selectPptSolicitante(sol: any) {
    this.formData.pptSolicitanteId = sol.id;
    this.formData.pptSolicitanteNombre = sol.nombre;
    this.filteredPptSolicitantes = [];
  }

  clearPptSolicitante() {
    this.formData.pptSolicitanteId = 0;
    this.formData.pptSolicitanteNombre = '';
    this.filteredPptSolicitantes = [];
  }

  async save() {
    if (this.currentItem.descripcion) {
      await this.metodosUi.showToast('Tienes un item pendiente por agregar.', 'warning');
      return;
    }

    // Validate standalone required fields
    if (!this.trabajo) {
      if (!this.formData.cliente || !this.formData.solicitante) {
        await this.metodosUi.showToast('Cliente y solicitante son obligatorios', 'warning');
        return;
      }
    }

    if (this.items.length === 0 || this.calcTotal <= 1) {
      await this.metodosUi.showToast('La cotización debe tener items y un monto mayor a $1.00', 'warning');
      return;
    }

    const hasPptMonto = Number(this.formData.pptMonto) > 0;
    if (hasPptMonto) {
      if (!this.formData.pptSolicitanteId || this.formData.pptSolicitanteId === 0) {
        await this.metodosUi.showToast('Debes seleccionar un solicitante válido de la lista para el PPT', 'warning');
        return;
      }
    }
    const userJson = localStorage.getItem('user');
    let usuario = '';
    if (userJson) { const user = JSON.parse(userJson); usuario = user.l_usuario || ''; }

    // Sanitize all items and observacion before saving
    this.items.forEach(item => {
      item.descripcion = this.sanitizeText(item.descripcion);
    });
    this.formData.observacion = this.sanitizeText(this.formData.observacion);
    this.updateDescription();

    // En modo clone los items vienen con los id reales de cotizaciones_items de la original.
    // Si se envían con id > 0 el SP los trata como UPDATE/DELETE del item original,
    // borrando los registros de la cotización base. Se resetean a 0 para forzar INSERT.
    const itemsToSend = this.isClone
      ? this.items.map(item => ({ ...item, id: 0 }))
      : this.items;

    const payload = {
      cotizacion: {
        id: this.isClone ? 0 : this.cotizacionId,
        trabajoId: this.isClone 
          ? (this.trabajo?.id || 0)
          : (this.parentType === 'solicitud' 
            ? (this.cotizacionData?.trabajoId || 0) 
            : (this.trabajo?.id || this.cotizacionData?.trabajoId || 0)),
        estado: this.formData.estado,
        clienteId: this.selectedClienteId || 0,
        direccionId: this.selectedDireccionId || 0,
        solicitanteId: this.selectedSolicitanteId || 0,
        fechaCot: this.formData.fechaCot,
        descripcion: this.formData.descripcion,
        precio: this.calcSubtotal,
        itbms: this.calcItbms,
        precioTotal: this.calcTotal,
        materiales: this.formData.materiales ? 'Y' : 'N',
        ppc: this.formData.ppc ? 'Y' : 'N',
        observacion: this.formData.observacion,
        pptEnabled: hasPptMonto ? 'Y' : 'N',
        pptSolicitanteId: hasPptMonto ? this.formData.pptSolicitanteId : 0,
        pptMonto: hasPptMonto ? this.formData.pptMonto : 0,
        pptFechaApply: hasPptMonto ? this.formData.pptFechaApply : null
      },
      items: itemsToSend,
      usuario: usuario
    };


    this.isSaving = true;
    try {
      const result = await firstValueFrom(this.javapiService.insertaCotizacion(payload));
      
      // Auto-link if from inspection
      if (this.inspeccionId > 0 && result && result.id) { // In insertaCotizacion, result is often {id, success}
        const linkPayload = this.metodosGenService.setModeloGeneral(
          'genUpdate', 'linkInspeccionCotizacion',
          String(this.inspeccionId), String(result.id), usuario,
          '', '', '', '', '', '', '', '', '', '', '', ''
        );
        await firstValueFrom(this.javapiService.getCommonModel(linkPayload));
      }

      await this.metodosUi.showToast('Cotización guardada exitosamente', 'success');
      this.modalCtrl.dismiss({ action: 'saved', data: result });
    } catch (e: any) {
      console.error('Error saving cotizacion:', e);
      await this.metodosUi.showToast('Error al guardar la cotización', 'danger');
    } finally {
      this.isSaving = false;
    }
  }

  originalDescText: string = '';
  improvedDescText: string = '';
  selectedDescMode: 'original' | 'ai' | null = null;
  isImprovingDesc: boolean = false;
  aiAttemptStatus: string = 'Mejorar con IA';

  async mejorarDescripcionConIA() {
    if (!this.currentItem.descripcion || !this.currentItem.descripcion.trim()) {
      await this.metodosUi.showToast('Ingresa una descripción corta antes de mejorarla', 'warning');
      return;
    }

    // Guardar el texto original antes de llamar a la IA
    this.originalDescText = this.currentItem.descripcion;

    this.isImprovingDesc = true;
    this.aiAttemptStatus = 'Mejorando...';
    try {
      // 1. Obtener los parámetros de configuración de la BD
      const paramRes = await firstValueFrom(this.javapiService.getJsonParam('CONFIG_IA_MEJORAR_DESC'));
      let model = undefined;
      let temperature = undefined;
      let systemInstruction = undefined;
      let freeAttempts = 2;
      let payAttempts = 1;
      let forcePay = false;

      if (paramRes && paramRes.pa_json) {
        try {
          const config = typeof paramRes.pa_json === 'string' ? JSON.parse(paramRes.pa_json) : paramRes.pa_json;
          model = config.model;
          temperature = config.temperature;
          systemInstruction = config.system_instruction;
          
          if (config.free_attempts !== undefined) freeAttempts = Number(config.free_attempts);
          if (config.pay_attempts !== undefined) payAttempts = Number(config.pay_attempts);
          if (config.force_pay !== undefined) forcePay = !!config.force_pay;
        } catch (parseErr) {
          console.error('Error parseando JSON de CONFIG_IA_MEJORAR_DESC', parseErr);
        }
      }

      // 2. Generar lista de intentos (true = usar clave de pago, false = clave gratuita)
      const attemptsList: boolean[] = [];
      if (forcePay) {
        for (let i = 0; i < payAttempts; i++) {
          attemptsList.push(true);
        }
      } else {
        for (let i = 0; i < freeAttempts; i++) {
          attemptsList.push(false);
        }
        for (let i = 0; i < payAttempts; i++) {
          attemptsList.push(true);
        }
      }
      if (attemptsList.length === 0) {
        attemptsList.push(false);
      }

      let res = null;
      let success = false;
      const totalAttempts = attemptsList.length;

      for (let idx = 0; idx < totalAttempts; idx++) {
        const usePayKey = attemptsList[idx];
        const attempt = idx + 1;
        if (usePayKey) {
          this.aiAttemptStatus = `Intento ${attempt}/${totalAttempts} (Pago)...`;
        } else {
          this.aiAttemptStatus = `Intento ${attempt}/${totalAttempts}...`;
        }

        try {
          res = await firstValueFrom(
            this.javapiService.mejorarDescripcion(
              this.currentItem.descripcion,
              systemInstruction,
              model,
              temperature,
              usePayKey,
              attempt,
              totalAttempts
            )
          );

          if (res && res.enhancedText) {
            success = true;
            break; // Salida del bucle si fue exitoso
          } else if (res && res.error) {
            console.warn(`Intento ${attempt}/${totalAttempts} fallido con error de IA:`, res.error);
          } else {
            console.warn(`Intento ${attempt}/${totalAttempts} fallido. Respuesta inválida.`);
          }
        } catch (attemptErr) {
          console.error(`Error en intento ${attempt}/${totalAttempts}:`, attemptErr);
        }

        // Esperar 1 segundo antes del siguiente intento
        if (attempt < totalAttempts) {
          await new Promise(r => setTimeout(r, 1000));
        }
      }

      if (!success) {
        throw new Error(res && res.error ? res.error : `No se pudo mejorar la descripción tras ${totalAttempts} intentos.`);
      }

      if (res && res.enhancedText) {
        this.improvedDescText = res.enhancedText;
        this.selectedDescMode = 'ai';
        this.currentItem.descripcion = this.improvedDescText;
        await this.metodosUi.showToast('Descripción mejorada con IA cargada.', 'success');
      }
    } catch (err: any) {
      console.error('Error al mejorar descripción:', err);
      await this.metodosUi.showToast(err?.message || 'Error al mejorar la descripción con IA', 'danger');
    } finally {
      this.isImprovingDesc = false;
      this.aiAttemptStatus = 'Mejorar con IA';
    }
  }

  toggleDescMode(mode: 'original' | 'ai') {
    // Si el usuario modificó manualmente el textarea, guardamos el cambio en la versión actualmente activa
    if (this.selectedDescMode === 'original') {
      this.originalDescText = this.currentItem.descripcion;
    } else if (this.selectedDescMode === 'ai') {
      this.improvedDescText = this.currentItem.descripcion;
    }

    this.selectedDescMode = mode;

    if (mode === 'original') {
      this.currentItem.descripcion = this.originalDescText;
    } else {
      this.currentItem.descripcion = this.improvedDescText;
    }
  }

  ajustePrecio: number | null = null;

  aplicarAjuste(operacion: 'sumar' | 'restar') {
    const monto = Number(this.ajustePrecio) || 0;
    if (monto <= 0) return;

    if (operacion === 'sumar') {
      this.currentItem.preUni = Number((this.currentItem.preUni + monto).toFixed(2));
    } else {
      this.currentItem.preUni = Number(Math.max(0, this.currentItem.preUni - monto).toFixed(2));
    }

    this.calculateItemTotal();
    this.ajustePrecio = null; // reset
  }
}
